import HistoryComp from "../../components/history/HistoryComp";

function History() {

  return (
    <HistoryComp/>
  );
}

export default History;